import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(": "),_c(VTextField,{attrs:{"type":"text","value":_vm.value,"name":_vm.name,"placeholder":_vm.placeholder},on:{"input":function($event){return _vm.$emit('input',$event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }